import React from 'react';
const ProfileBox = ({ name, profile_pic }) => (
    <div className="pf-profilebox">
        <div className="pf-img-name" data-aos="fade-right">
            <img src={profile_pic} className="pf-pic" />
            <p>{name}</p>
        </div>

    </div>
)

export default ProfileBox